import { Toast } from 'vant'
import dataObj from '@/common/date.js'
import betterwe from '@/common/app-common.js'
const config = {
  anmationTime: 0.5 //每一格的动画时间
}

//每日装水提示
const fullCupDailyTips = {
  1: [
    {
      id: 'ripple-content',
      top: 0,
      direction: 'top',
      text: '今天的水已经灌满啦～正确喝水是养<br/>成易瘦体质的关键，让咱们开始吧！'
    }
  ],
  2: [
    {
      id: 'ripple-content',
      top: 0,
      direction: 'top',
      text: '今天的水已经灌满啦<br/>让我们开始喝水打卡吧'
    }
  ]
}
//首次装水提示
const fullCupFirstTips = {
  1: [
    {
      id: 'ripple-content',
      top: 0,
      direction: 'top',
      text: `这是您的每日推荐饮水量，请明日<br/>起床时，将水灌至<span style='display:inline-block;width: 12px;height: 8px;background: <placeholder1>;
      border-radius: 2px;margin:0px 2px'></span><placeholder2>色格哦`
    }
  ],
  2: [
    {
      id: 'ripple-content',
      top: 0,
      direction: 'top',
      text: `这是您的每日推荐饮水量`
    }
  ]
}
const tipsStepList = {
  1: [
    {
      id: 'drink-target',
      top: 0,
      direction: 'top',
      text: '营养师根据您的身体数据为<br/>您匹配了最合适的饮水目标'
    },
    {
      id: 'set-btn',
      top: 100,
      direction: 'bottom',
      text: '根据您的喝水目标，<br/>我们每日将进行7次提醒'
    },
    {
      id: 'clock-btn',
      top: 0,
      direction: 'top',
      text: '每次提醒后，您只需喝掉对<br/>应色彩，点击此处打卡即可'
    }
  ],
  2: [
    {
      id: 'set-btn',
      top: 104,
      direction: 'bottom',
      text: '根据您的喝水目标，<br/>我们每日将进行8次提醒'
    },
    {
      id: 'clock-btn',
      top: 0,
      direction: 'top',
      text: '每次提醒后，您只需要喝掉<br/>对应的水量，点击此处打卡即可'
    }
  ]
}
const drinkSuccessHtml = `<div style="font-size: 14px;font-family: PingFangSC-Regular, PingFang SC;
color: rgba(0, 0, 0, 0.6);line-height: 24px;margin-bottom: 20px;">{{}}</div>
<div style='background-color: #E1F2FF;
background-image:url("https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/488d61a8f495686a97c5b810046ead8e.png");
background-size:30%;background-position:right bottom;background-repeat:no-repeat;border-radius: 6px;padding:16px 24px'>
<div style='font-size: 14px;
font-family: PingFangSC-Medium, PingFang SC;font-weight: 600;color: #1F57DC;line-height: 24px;display:flex;align-items:center;justify-content: center;'>
  <div style="flex:1;height: 0px;border-bottom: 1px solid;border-image: linear-gradient(90deg, rgba(138, 183, 244, 0), rgba(82, 128, 229, 1)) 1 1;"></div>
<div style="margin:0 6px;white-space:nowrap">喝水小知识</div>
<div style="flex:1;height: 0px;border-bottom: 1px solid;border-image: linear-gradient(90deg, rgba(138, 183, 244, 0), rgba(82, 128, 229, 1)) 1 1;"></div>
</div>
<div style='font-size: 12px;
font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #1F57DC;line-height: 22px;text-align:left'>{{}}</div>
</div>`
const shadowList = [
  'inset 0px -1px 3px 0px rgba(0,0,0,0.05), inset 0px 1px 3px 0px rgba(0,0,0,0.05)',
  'inset 0px -1px 3px 0px rgba(98, 54, 255, 0.41), inset 0px 1px 3px 0px #EDE8FF',
  'inset 0px -1px 3px 0px #C44FED, inset 0px 1px 3px 0px #FAECFF',
  'inset 0px -1px 3px 0px #C44FED, inset 0px 1px 3px 0px #FAECFF',
  'inset 0px -1px 3px 0px #467BF8, inset 0px 1px 3px 0px #E8ECFF',
  'inset 0px -1px 3px 0px #A8E5F8, inset 0px 1px 3px 0px #E5F0FB',
  'inset 0px -1px 3px 0px #64D0A7, inset 0px 1px 3px 0px #CBFFEA',
  'inset 0px -1px 3px 0px rgba(255, 217, 61, 0.62), inset 0px 1px 3px 0px rgba(255, 221, 4, 0.3)',
  'inset 0px -1px 3px 0px #FFA163, inset 0px 1px 3px 0px #FFF3E8',
  'inset 0px -1px 3px 0px #FE6B6B, inset 0px 1px 3px 0px #FFE8E8'
]
const btnList = [
  {
    btn: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/drink_water_reminder_btn_1',
    text: '秀秀成果'
  },
  {
    btn: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/drink_water_reminder_btn_1',
    text: '喝水打卡'
  },
  {
    btn: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/drink_water_reminder_btn_8',
    text: '喝水打卡'
  },
  {
    btn: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/drink_water_reminder_btn_8',
    text: '喝水打卡'
  },
  {
    btn: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/drink_water_reminder_btn_7',
    text: '喝水打卡'
  },
  {
    btn: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/drink_water_reminder_btn_6',
    text: '喝水打卡'
  },
  {
    btn: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/drink_water_reminder_btn_5',
    text: '喝水打卡'
  },
  {
    btn: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/drink_water_reminder_btn_4',
    text: '喝水打卡'
  },
  {
    btn: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/drink_water_reminder_btn_3',
    text: '喝水打卡'
  },
  {
    btn: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/drink_water_reminder_btn_2',
    text: '喝水打卡'
  }
]

//获取需要设置行程的时间数组 时间为5天
const getTimeArr = function (list) {
  let day = 5
  let res = []
  for (let i = 0; i < day; i++) {
    list.map((item) => {
      let obj = {
        startTime: toTimeStr(item.time_slot, i, 0),
        endTime: toTimeStr(item.time_slot, i, 5)
      }
      res.push(obj)
    })
  }
  return res
}
//根据字符串获取时间 index：距离今天的天数   duration:行程时间 单位分钟
const toTimeStr = function (str, index, duration = 0) {
  let hours = parseInt(str.split(':')[0])
  let minute = parseInt(str.split(':')[1])
  let today = new Date(new Date().toLocaleDateString()).getTime() //今天凌晨0点
  let dayTime = 1000 * 60 * 60 * 24
  let cur =
    today +
    dayTime * index +
    hours * 1000 * 60 * 60 +
    (minute + duration) * 1000 * 60
  return dataObj.getFullTimeStr(cur)
}
const Calendar = {
  lowestVersion: 59, //日历提醒的最低版本要求
  calendarName: '喝水提醒',
  calendarAccountName: 'betterWE星球',
  //是否允许显示日历 app版本低于59则不显示
  async allowCalendar() {
    return new Promise((resolve, reject) => {
      betterwe
        .getAppDevicesInfo()
        .then((res) => {
          if (res.clientversion >= Calendar.lowestVersion) {
            resolve(true)
          }
          resolve(false)
        })
        .catch((err) => {
          resolve(false)
        })
    })
  },
  //设置日历事件id 只设置不更新
  setCalendarEvent(id, data) {
    if (id) {
      return new Promise(async (resolve, reject) => {
        let accountName = 'betterWE星球'
        let info = await betterwe.getAppDevicesInfo().catch(() => {})
        if (info) {
          if (info.clientplatform == 2) {
            accountName = 'iCloud'
          }
          let res = await betterwe
            .commonMethod('calendarChannelMethod', {
              methodType: 'createOrUpdateCalendarEvent',
              params: JSON.stringify({
                calendarAccountName: accountName, //日历账户本地手机的名字 可不传 默认app的名字
                calendarId: id, //日历的id , 如果没有这个日历账户 则会自动新增日历账户 如果有,则往这个日历账户中添加
                calendarName: '喝水提醒', //日历账户的名字 建议传 按照功能模块来命名 比如说喝水提醒 默认app的名字
                eventId: '', //事件id,没有此事件会创建事件，如果有就更新事件
                description: '每日喝水提醒', //事件的描述
                eventTitle: '每日喝水提醒', //事件的title
                url: '', //事件的url
                allDay: 0, //是否是全天时间 0否 1是 默认0
                availability: 2, //暂无作用 默认2
                recurrenceInterval: 1, //提醒的间隔时间
                recurrenceMethod: 0, //提醒的间隔方式 1: 天 2:周 3:月 4:年
                remindersTimeMinutes: 5, //事件出发前几分钟提醒
                startTime: data.startTime, //事件的开始时间
                endTime: data.endTime //事件的结束时间}),
              })
            })
            .catch(() => {})
          if (res) {
            res = JSON.parse(res)
            if (res.code == 0) {
              resolve(res)
            } else {
              reject(res)
            }
          }
        }
      })
    } else {
      return Promise.reject({ message: 'id不能为空' })
    }
  },
  setCalendarEvents(id, list) {
    if (Array.isArray(list) && list.length) {
      let arr = []
      for (let i = 0; i < list.length; i++) {
        arr.push(Calendar.setCalendarEvent(id, list[i]))
      }
      return Promise.all(arr)
    } else {
      return Promise.reject()
    }
  },
  //删除日历事件
  deleteCalendarEvent(id, eventId) {
    betterwe.commonMethod('calendarChannelMethod', {
      methodType: 'deleteCalendarEvent',
      params: JSON.stringify({
        calendarId: id,
        eventId: eventId
      })
    })
  },
  //设置日历 返回日历的id
  setCalendar(values) {
    return new Promise(async function (resolve, reject) {
      let info = await betterwe.getAppDevicesInfo().catch(() => {})
      if (info) {
        let accountName = 'betterWE星球'
        if (info.clientplatform == 2) {
          accountName = 'iCloud'
        }
        let res = await betterwe
          .commonMethod('calendarChannelMethod', {
            methodType: 'createCalendar',
            params: JSON.stringify({
              calendarName: '喝水提醒',
              calendarAccountName: accountName
            })
          })
          .catch(() => {})
        if (res) {
          let setRes = JSON.parse(res)
          if (setRes.code == 0) {
            Calendar.setCalendarEvents(setRes.calendarId, values)
              .then((res) => {
                resolve(setRes)
              })
              .catch((res) => {
                reject(res)
              })
          } else {
            reject(setRes)
          }
        }
      }
    })
  },
  //根据id查找是否有这个日历
  hasCalendar(id) {
    return new Promise(async function (resolve, reject) {
      let res = await betterwe.commonMethod('calendarChannelMethod', {
        methodType: 'isCalendars',
        params: JSON.stringify({
          calendarId: id
        })
      })
      if (res) {
        res = JSON.parse(res)
        if (res.code == 0) {
          resolve(res)
        } else {
          reject(res)
        }
      }
    })
  },
  //删除日历
  delCalendar: () => {
    return new Promise(async function (resolve, reject) {
      let res = await Calendar.getCalendarList()
      if (res && res.data) {
        let list = res.data
        let calendarId
        if (list && Array.isArray(list)) {
          for (let i = 0; i < list.length; i++) {
            if (list[i].name == Calendar.calendarName) {
              calendarId = list[i].id
              break
            }
          }
        }
        if (calendarId) {
          let res = await betterwe.commonMethod('calendarChannelMethod', {
            methodType: 'deleteCalendar',
            params: JSON.stringify({
              calendarId: calendarId
            })
          })
          if (res) {
            try {
              res = JSON.parse(res)
              if (res.code == 0) {
                resolve(res)
              } else {
                reject(res)
              }
            } catch (error) {
              reject()
            }
          }
        }
      }
    })
  },
  getCalendarList: () => {
    return new Promise(async function (resolve, reject) {
      let res = await betterwe.commonMethod('calendarChannelMethod', {
        methodType: 'getCalendarList',
        params: JSON.stringify({})
      })
      if (res) {
        try {
          res = JSON.parse(res)
          if (res.code == 0) {
            resolve(res)
          } else {
            reject(res)
          }
        } catch (error) {
          reject(error)
        }
      }
    })
  },

  /* 设置日历 */
  bindSetCalendar: function (timeList) {
    let timeArr = getTimeArr(timeList)
    return new Promise((resolve, reject) => {
      Calendar.setCalendar(timeArr)
        .then((res) => {
          resolve(res)
        })
        .catch((res) => {
          reject(res)
        })
    })
  },
  //是否有喝水提醒的日历
  haveDrinkCalendar() {
    return new Promise(async (resolve, reject) => {
      let res = await Calendar.getCalendarList()
      if (res && res.data) {
        let list = res.data
        if (list && Array.isArray(list)) {
          for (let i = 0; i < list.length; i++) {
            if (list[i].name == Calendar.calendarName) {
              resolve(true)
              break
            }
          }
        }
        resolve(false)
      }
      reject()
    })
  },
  //更新日历
  updateCalendar: function (timeList) {
    Calendar.haveDrinkCalendar()
      .then((res) => {
        if (res) {
          let timeArr = getTimeArr(timeList)
          Calendar.setCalendar(timeArr)
            .then((res) => {})
            .catch((res) => {})
        }
      })
      .catch(() => {})
  }
}
//切换彩虹杯 timeList 时间 isSetCalendar 是否重新设置日历行程
const switchCalendar = async function (timeList) {
  let timeArr = getTimeArr(timeList)
  let allow = await Calendar.allowCalendar()
  if (allow) {
    /* 获取日历事件列表 */
    let res = await Calendar.getCalendarList()
    if (res && res.data) {
      let list = res.data
      let calendarId
      if (list && Array.isArray(list)) {
        for (let i = 0; i < list.length; i++) {
          if (list[i].name == Calendar.calendarName) {
            calendarId = list[i].id
            break
          }
        }
      }
      if (calendarId) {
        Calendar.setCalendar(timeArr)
      }
    }
  }
}

export {
  tipsStepList,
  shadowList,
  btnList,
  config,
  fullCupDailyTips,
  fullCupFirstTips,
  drinkSuccessHtml,
  Calendar,
  getTimeArr,
  switchCalendar
}
